import type { Organization, User } from "../stores/authStore";

const ADMIN_ROLES = new Set(["org_admin", "site_admin"]);

/**
 * True when the user is allowed to write resources scoped to the given org —
 * either a platform super-admin, or holds an org_admin / site_admin role in
 * that organization. Mirrors backend `require_site_access` with admin roles.
 */
export function canAdminOrg(
  user: User | null,
  organizations: Organization[],
  orgId: string | null,
): boolean {
  if (!user) return false;
  if (user.is_superuser) return true;
  if (!orgId) return false;
  const org = organizations.find((o) => o.id === orgId);
  if (!org) return false;
  return org.roles.some((r) => ADMIN_ROLES.has(r.role));
}
